import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'portal-submission-success',
  templateUrl: './submission-success.component.html',
  styleUrls: ['./submission-success.component.scss']
})
export class SubmissionSuccessComponent implements OnInit {
  confirmationNumMsg: string;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { token: number; from: string; to: string }
  ) {}

  ngOnInit() {
    const { token, from, to } = this.data;
    this.confirmationNumMsg = `
    Your confirmation number is ${token || 'N/A'}.
    Your ad will be curated for display from ${from || 'N/A'} through ${to ||
      'N/A'}.`;
  }
}
